export default __webpack_public_path__ + "static/media/2.ae4696ae.png";